// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bees-chart circle{
  transition:opacity .1s linear
}

.bees-chart .highlighted-node circle:not(.highlighted){
  opacity:.1 !important
}

.bees-chart .grid-x .domain{
  stroke:rgba(100,100,100,0)
}

.bees-chart .grid-y .domain{
  stroke:rgba(0,0,0,0)
}

.bees-chart .grid-x line{
  stroke:#ebecf0
}

.bees-chart .grid-y line{
  stroke:#ebecf0
}

.bees-chart .domain{
  stroke:#787896;
  opacity:.3
}

.bees-chart .selected{
  stroke-width:2px;
  stroke:red
}

.bees-chart .bees-chart-x-axis{
  overflow:visible !important
}

.bees-chart .axis-container text{
  font-weight:600;
  stroke:rgba(0,0,0,0);
  fill:#6e6e82;
  font-size:10px
}`, "",{"version":3,"sources":["webpack://./src/js/components/Publications/components/TimeLine/beeswarm.scss"],"names":[],"mappings":"AACE;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAEF;EACE,cAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,eAAA;EACA,oBAAA;EACA,YAAA;EACA;AAAA","sourcesContent":[".bees-chart {\n  circle {\n    transition: opacity 0.1s linear;\n  }\n\n  .highlighted-node circle:not(.highlighted) {\n    opacity: 0.1 !important;\n  }\n\n  .grid-x .domain {\n    stroke: rgba(100, 100, 100, 0);\n  }\n\n  .grid-y .domain {\n    stroke: transparent;\n  }\n\n  .grid-x line {\n    stroke: rgb(235, 236, 240);\n  }\n\n  .grid-y line {\n    stroke: rgb(235, 236, 240);\n  }\n  .domain {\n    stroke: rgb(120, 120, 150);\n    opacity: 0.3;\n  }\n\n  .selected {\n    stroke-width: 2px;\n    stroke: red;\n  }\n\n  .bees-chart-x-axis {\n    overflow: visible !important;\n  }\n\n  .axis-container text {\n    font-weight: 600;\n    stroke: transparent;\n    fill: rgb(110, 110, 130);\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
